export const CREATE_PASSWORD_REQUEST = "CREATE_PASSWORD_REQUEST";
export const CREATE_PASSWORD_SUCCESS = "CREATE_PASSWORD_SUCCESS";
export const CREATE_PASSWORD_FAIL = "CREATE_PASSWORD_FAIL";
export const CREATE_PASSWORD_RESET = "CREATE_PASSWORD_RESET";
